import { ReactNodeViewRenderer } from '@tiptap/react'

import {
  MentionNodeAttributes,
  MentionNode as SharedMentionNode,
} from '~shared/richtext/nodes/mention.node'

import { getMentionFromCache } from '@/entities/mentions'

import { MentionNodeViewLive } from './MentionNodeView'
import { createMentionsSuggestion } from './MentionsSuggestion'

/**
 * Extends our custom `MentionNode` with client-only features.
 */
export const MentionNode = SharedMentionNode.extend({
  renderText({ node }) {
    const attrs = node.attrs as MentionNodeAttributes

    const mention = getMentionFromCache(attrs.mentionId)

    const currentName = mention?.name
    const fallbackName = attrs.fallbackName ?? 'unknown'

    return `@${currentName ?? fallbackName}`
  },

  addNodeView() {
    return ReactNodeViewRenderer(MentionNodeViewLive)
  },

  addProseMirrorPlugins() {
    return [
      createMentionsSuggestion({
        name: this.name,
        editor: this.editor,
      }),
    ]
  },
})
